import 'overlayscrollbars/styles/overlayscrollbars.css';
import { OverlayScrollbars, ScrollbarsHidingPlugin } from 'overlayscrollbars';
import Vue from 'vue';
Vue.directive('overlay-scrollbars', {
  // When the bound element is inserted into the DOM...
  inserted: function inserted(el) {
    // apply overlay scrollbars to the element
    OverlayScrollbars.plugin(ScrollbarsHidingPlugin);

    if (el.dataset.scrollbarsContainerClass) {
      el = el.querySelector(".".concat(el.dataset.scrollbarsContainerClass));
    }

    OverlayScrollbars(el, {
      scrollbars: {
        autoHide: 'move'
      }
    });
  }
});